<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Pesquisa</h1>

      <div class="btn-container">
        <button type="button"
          class="btn-toggle mb-3 v-btn v-btn--has-bg theme--light v-size--default primary button-orientation"
          @click="alternarFiltro">
          {{ mostrarFiltro ? 'Ocultar filtros' : 'Mostrar filtros' }}
        </button>
        <ModosWebFiltroInlineCollapseComponent ref="filtroInline" :campos="camposFiltrosComputed" :key="filtroKey"
          :inicialOpen="true" :esconderBotao="true" @open-change="mostrarFiltro = $event"
          @modosWebFormFilterDadosClick="aplicarFiltro"
          @modosWebFormFilterLimpar="resetarFiltro" />
      </div>

      <template v-if="dadosPesquisa.length">
        <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao?.current_page">

          <SGPTabelaComponent
            :colunas="colunas"
            :dados="dadosPesquisa"
            :usuarioPodeEditar="false"
            :usuarioPodeExcluir="false"
            :botaoInline="false"
            :somenteLeitura="true"
          >
            <template v-slot:item.centro_funcional="{ item }">
              <CentroFuncionalBadge
                :valor="item.centro_funcional"
                :area-tecnica="item.provedor_recuperacao?.area_tecnica || item.area_tecnica"
              />
            </template>
          </SGPTabelaComponent>
        </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingPesquisa" />
    </div>
  </div>
</template>

<style scoped>
.btn-container {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: flex-end !important;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex'
import ModosWebFiltroInlineCollapseComponent from '@/common/modosweb-components/ModosWebFiltroInlineCollapseComponent.vue'
import { normalizarPesquisa } from '../helpers/pesquisaNormalizer.js'
import { colunasParaTipos } from '../helpers/pesquisaColunas.js'
import moduleReload from '@/common/mixins/module-reload.js'
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import CentroFuncionalBadge from '@/common/sgp-components/CentroFuncionalBadge.vue'
import { centroFuncionalOpcoes } from '@/common/helpers/centroFuncional'

export default {
  name: 'PesquisaPage',

  mixins: [moduleReload],

  components: {
    ModosWebFiltroInlineCollapseComponent,
    CentroFuncionalBadge,
  },

  data() {
    return {
      mostrarFiltro: true,
      filtro: {},
      filtroKey: 1
    }
  },
  async created() {
    const promises = [
      this.listarProvedores(),
      this.listarCtrlStatus(),
      this.listarCtrlEstados(),
    ]

    if(this.moduloAtivo == CTRL_MODULOS.INSTALACAO){
      promises.push(
        this.listarRegionaisPermitidas(),
        this.listarTiposServico(),
        this.listarTiposSolicitacao()
      )
    }

    await Promise.all(promises)

    await this.pesquisar(this.montarParametros())
  },
  computed: {
    ...mapGetters('pesquisa', ['listaDeDadosPesquisa', 'loadingPesquisa', 'paginacao']),
    ...mapGetters('ctrlProvedores', ['listaDeProvedores']),
    ...mapGetters('ctrlRegionais', ['listaDeRegionais']),
    ...mapGetters('ctrlTipoServico', ['listaDeTiposServico']),
    ...mapGetters('ctrlTipoSolicitacao', ['listaDeTiposSolicitacao']),  
    ...mapGetters('ctrlEstadosWf', ['listaDeCtrlEstados']),
    ...mapGetters('ctrlStatus', ['listaDeCtrlStatus']),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),

    camposFiltrosComputed() {
      if(this.moduloAtivo == CTRL_MODULOS.INSTALACAO){
        return this.getCamposFiltroInstalacao()
      }
        
      if(this.moduloAtivo == CTRL_MODULOS.RECUPERACAO){
        return this.getCamposFiltroRecuperacao()
      }
      return [];
    },

    dadosPesquisa() {
      return this.listaDeDadosPesquisa.map(normalizarPesquisa)
    },

    colunas() {
      return colunasParaTipos(this.moduloAtivo)
    }
  },

  methods: {
    ...mapActions('pesquisa',['pesquisar']),
    ...mapActions('ctrlProvedores', ['listarProvedores']),
    ...mapActions('ctrlRegionais', ['listarRegionaisPermitidas']),
    ...mapActions('ctrlTipoServico', ['listarTiposServico']),
    ...mapActions('ctrlTipoSolicitacao', ['listarTiposSolicitacao']),
    ...mapActions('ctrlEstadosWf', ['listarCtrlEstados']),
    ...mapActions('ctrlStatus', ['listarCtrlStatus']),

    alternarFiltro() {
      this.mostrarFiltro = !this.mostrarFiltro;
      if (this.$refs.filtroInline && this.$refs.filtroInline.toggleOpen) {
        this.$refs.filtroInline.toggleOpen();
      }
    },

    async resetarFiltro() {
      this.filtro = {};
      this.filtroKey++;  
      
      await this.pesquisar(this.montarParametros());
    },

    async aplicarFiltro(dados) {
      this.filtro = dados || {};
      await this.pesquisar(this.montarParametros());
    },

    montarParametros(extra = {}) {
      const { centro_funcional, ...filtro } = this.filtro
      return {
        per_page: this.paginacao?.per_page || 20,
        current_page: this.paginacao?.current_page || 1,
        ...filtro,
        ...(centro_funcional ? { centro_funcional } : {}),
        ...extra,
      }
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1
      const perPage = paginate.per_page || this.paginacao?.per_page || 20
      this.pesquisar(
        this.montarParametros({
          current_page: current,
          per_page: perPage
        })
      )
    },

    async reloadData() {
      this.filtro = {};
      this.filtroKey++;
      await this.pesquisar(this.montarParametros());
    },

    getCamposFiltroRecuperacao() {
      return [
        { 
          name: 'rec',
          type: 'text',
          label: 'REC'
        },
        { 
          name: 'numero_protocolo',
          type: 'text',
          label: 'Número do Protocolo'
        },
        { 
          name: 'cliente_final',
          type: 'text',
          label: 'Cliente final'
        },
        { 
          name: 'ctrl_provedor_id',
          type: 'auto_complete',
          label: 'Provedor',
          options: this.listaDeProvedores.map(item => {
            return { value: item.id, text: item.nome }
          })
        },
        {
          name: 'centro_funcional',
          type: 'select',
          label: 'Centro Funcional',
          options: centroFuncionalOpcoes
        },
        { 
          name: 'designacao',
          type: 'text',
          label: 'Designação'
        },
        { 
          name: 'designacao_provedor',
          type: 'text',
          label: 'Designação Provedor'
        },
        { 
          name: 'data_abertura',
          type: 'range',
          time: false,
          label: 'Data de abertura'
        },
        { 
          name: 'data_fechamento',
          type: 'range',
          time: false,
          label: 'Data de fechamento'
        },
        { 
          name: 'ctrl_status_id',
          type: 'select',
          label: 'Status',
          options: this.listaDeCtrlStatus.map(item => {
            return { value: item.id, text: item.status }
          })
        },
        { 
          name: 'uf',
          type: 'select',
          label: 'UF',
          options: this.listaDeCtrlEstados.map(item => {
            return { value: item.uf, text: item.uf }
          })
        },
      ]
    },

    getCamposFiltroInstalacao() {
      return [
        { 
          name: 'ctrl_provedor_id',
          type: 'select',
          label: 'Provedores',
          options: this.listaDeProvedores.map(item => {
            return { value: item.id, text: item.nome }
          })
        },
        { 
          name: 'ctrl_regional_id',
          type: 'select',
          label: 'Regionais',
          options: this.listaDeRegionais.map(item => {
            return { value: item.id, text: item.regional }
          })
        },
        { 
          name: 'ctrl_tipo_servico_id',
          type: 'select',
          label: 'Tipos de Serviços',
          options: this.listaDeTiposServico.map(item => {
            return { value: item.id, text: item.nome }
          })
        },
        { 
          name: 'ctrl_status_id',
          type: 'select',
          label: 'Status das Solicitações',
          options: this.listaDeCtrlStatus.map(item => {
            return { value: item.id, text: item.status }
          })
        },
        { 
          name: 'ctrl_tipo_solicitacao_id',
          type: 'select',
          label: 'Tipos de Solicitações',
          options: this.listaDeTiposSolicitacao.map(item => {
            return { value: item.id, text: item.nome }
          })
        },
        { 
          name: 'ctrl_estado_id',
          type: 'select',
          label: 'UF\'s',
          options: this.listaDeCtrlEstados.map(item => {
            return { value: item.id, text: item.uf }
          })
        },
        { name: 'data_abertura', type: 'range', time: false, label: 'Data de abertura' },
        { name: 'data_fechamento', type: 'range', time: false, label: 'Data de fechamento' },
      ]
    },
  }
}
</script>
